export default __webpack_public_path__ + "media/images/lp/conversion-main-sp-36fc076cb7f5547bbffe9e97587a8b28.png";